import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseSiteService, GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { skip, take } from 'rxjs/operators';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import { MFA_TEMPORARY_DISABLE } from 'src/app/shared/modules/release-banner/constants';
import { FeatureFlagService } from 'src/app/shared/services/feature-flag.service';
import { MultiFactorAuthService } from 'src/app/shared/services/multi-factor-auth.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { UserAccessManagementService } from '../user-access-management.service';

@Component({
    selector: 'app-customer-overview',
    templateUrl: './customer-overview.component.html',
    styleUrls: ['./customer-overview.component.scss'],
    standalone: false
})
export class CustomerOverviewComponent implements OnInit, OnDestroy {
  nameEditIsNotClicked = true;
  roleEditIsNotClicked = true;
  passwordEditIsNotClicked = true;
  passRecEditIsNotClicked = true;
  emailEditIsNotClicked = true;
  commConfmEditIsNotClicked = true;
  mobileEditIsNotClicked = true;
  nameForm: FormGroup;
  passwordForm: FormGroup;
  emailForm: FormGroup;
  alternateEmailForm: FormGroup;
  mobileForm: FormGroup;
  mobileNumber: string = '';
  mobileNumberMasked: string = '';
  mobileErrorMsg: string = null;
  mobileAddDisable = false;
  chosenRoleofUser = '';
  passwordYetToMatch: boolean;
  passwordIsNotValid = true;
  passwordConfirmStatus = '';
  chosenQueForPassRecovery = '';
  ansForQuePassRecovery = null;
  loginUserInfo: any;
  emailCommunicationStatus = '';
  userIdDisable: any = 'true';
  userIdDisableReadOnly: any;
  roleOfUserArray = [];
  passRecQuesArray = [];
  displayRoleofUser: any;
  displayQueForPassRecovery: any;
  showAlternateEmailField = false;
  currentPasswordIsNotValid = true;
  cPassError: any = '';
  emailRegex = '';
  userDtaaSubscriber: any;
  userRolesSubscriber: any;
  userDtaUpdateSubscriber: any;
  passQueSubscriber: any;
  userDataUpdateSubscriber2: any;
  changeLogArray: any = [];
  userIdEditIsNotClicked = true;
  // MFA Disabled Until
  mfaDisabledUntilEditIsNotClicked = true;
  mfaDisabledUntilSelectedDate: Date = null;
  mfaDisabledUntilHour = 0;
  mfaDisabledUntilMinute = 0;
  mfaDisabledUntilMinHour = 0;
  mfaDisabledUntilErrorMsg: string = null;
  mfaDisabledUntilErrorKey: string = null;
  mfaDisabledUntilErrorParams: any = {};
  mfaDisabledUntilMinDate: Date = new Date();
  mfaDisabledUntilMaxDate: Date = null;
  mfaDisabledUntilDisplay = '';
  mfaDisabledUntilDatepickerConfig = { dateInputFormat: 'MM/DD/YYYY', containerClass: 'order-list-date' };
  private mfaDisabledUntilOriginalIso: string | null = null;
  mfaDisabledUntilInFlight = false;
  showMfaDisabledUntil = false;
  private mfaFlagSub: Subscription;

  get mfaHourDisplay(): string { return String(this.mfaDisabledUntilHour).padStart(2, '0'); }
  get mfaMinuteDisplay(): string { return String(this.mfaDisabledUntilMinute).padStart(2, '0'); }

  onMfaHourInput(val: string) {
    const h = parseInt(val, 10);
    this.mfaDisabledUntilHour = isNaN(h) ? this.mfaDisabledUntilMinHour : Math.min(23, Math.max(this.mfaDisabledUntilMinHour, h));
    this.mfaDisabledUntilErrorMsg = null;
    this.mfaDisabledUntilErrorKey = null;
    this.mfaDisabledUntilErrorParams = {};
  }

  onMfaMinuteInput(val: string) {
    const m = parseInt(val, 10);
    this.mfaDisabledUntilMinute = isNaN(m) ? 0 : Math.min(59, Math.max(0, m));
    this.mfaDisabledUntilErrorMsg = null;
    this.mfaDisabledUntilErrorKey = null;
    this.mfaDisabledUntilErrorParams = {};
  }

  get isMfaDisabledUntilUnchanged(): boolean {
    if (!this.mfaDisabledUntilSelectedDate) {
      return !this.mfaDisabledUntilOriginalIso;
    }
    const combined = new Date(this.mfaDisabledUntilSelectedDate);
    combined.setHours(this.mfaDisabledUntilHour, this.mfaDisabledUntilMinute, 0, 0);
    if (!this.mfaDisabledUntilOriginalIso) { return false; }
    const originalMinute = Math.floor(new Date(this.mfaDisabledUntilOriginalIso).getTime() / 60000);
    const currentMinute = Math.floor(combined.getTime() / 60000);
    return currentMinute === originalMinute;
  }
  customerId: any;
  updateDetailsSubscriber: any;
  cstDetailsSubscriber: any;
  resetPasswordBoolean: any = null;
  changeHistorySubscriber: any;
  changeHistoryArray: any = [];
  baseSiteId: string;
  emailRegx = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/;
  emailChangeRequested;
  constructor(
    private readonly pfService: CustomProfileAndPreferencesService,
    private readonly user: UserAccountFacade,
    private readonly ref: ChangeDetectorRef,
    private readonly userManagementService: UserAccessManagementService,
    private readonly sharedService: SharedService,
    private readonly globalMessage: GlobalMessageService,
    private readonly router: Router,
    private baseSiteService: BaseSiteService,
    private mfaService: MultiFactorAuthService,
    private readonly featureFlagService: FeatureFlagService
  ) {}

  ngOnInit(): void {
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.customerId = this.sharedService.getSessionStorage('customerId');
    this.formInitialisation();
    this.mfaFlagSub = this.featureFlagService
      .getFlagObservable(MFA_TEMPORARY_DISABLE, false)
      .subscribe((enabled) => {
        this.showMfaDisabledUntil = enabled === true;
        this.ref.detectChanges();
      });
    this.cstDetailsSubscriber =
      this.userManagementService.customerDetails.subscribe((userData: any) => {
        if (userData?.res) {
          this.loginUserInfo = userData?.res;
          this.getChangeHistory();
          this.userIdDisableReadOnly =
            (this.loginUserInfo?.userDisabled).toString();
          this.userIdDisable = (this.loginUserInfo?.userDisabled).toString();
          this.mobileNumber = this.loginUserInfo?.mobileNumber || '';
          if (this.mobileNumber) {
            const countryCode = this.loginUserInfo?.mobileCountryCode || 'US';
            this.mobileNumberMasked = `(${countryCode}) ` + this.mobileNumber.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '***-***-$3');
          }
          if (userData?.id === null) {
            this.setAllFormField();
            this.userRoleGetMethod();
            this.getPassWordRecQues();
          } else {
            if (userData.id === 'name') {
              this.setNameField();
            } else if (userData.id === 'role') {
              this.userRoleGetMethod();
            } else if (userData.id === 'email') {
              this.setEmailForm();
            } else if (userData.id === 'mobile') {
              this.setMobileForm();
            } else if (userData.id === 'mobile') {
              this.setMobileForm();
            } else if (userData.id === 'mfa') {
              this.setMfaDisabledUntilField();
            } else {
              // No Change
            }
          }
          this.ref.detectChanges();
        }
      });
  }

  ngOnDestroy() {
    this.changeHistorySubscriber?.unsubscribe();
    this.updateDetailsSubscriber?.unsubscribe();
    this.passQueSubscriber?.unsubscribe();
    this.userRolesSubscriber?.unsubscribe();
    this.cstDetailsSubscriber?.unsubscribe();
    this.mfaFlagSub?.unsubscribe();
  }
  setAllFormField() {
    this.setNameField();
    this.setPassRecField();
    this.setEmailForm();
    this.setMobileForm();
    this.setMobileForm();
    this.setMfaDisabledUntilField();
  }
  // ===================================ChangeHistory===============================
  getChangeHistory() {
    this.userManagementService.getChangeHistory(this.customerId);
    this.changeHistorySubscriber =
      this.userManagementService.changeHistory.subscribe((data: any) => {
        if (data) {
          this.changeHistoryArray = [];
          this.changeHistoryArray = data?.modifiedEntries;
          this.ref.detectChanges();
        }
      });
  }
  // =======================All forms Initilaisation=============================
  formInitialisation() {
    this.nameForm = new FormGroup({
      actualFirstName: new FormControl('', [
        Validators.required,
        Validators.pattern("[a-zA-Z0-9 '-]*$"),
      ]),
      actualLastName: new FormControl('', [
        Validators.required,
        Validators.pattern("[a-zA-Z0-9 '-]*$"),
      ]),
    });
    this.passwordForm = new FormGroup({
      currentPassword: new FormControl('', Validators.required),
      newPassword: new FormControl('', Validators.required),
      confirmNewPassword: new FormControl('', Validators.required),
    });
    this.emailForm = new FormGroup({


      emailId: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern(this.emailRegx),
      ]),
      confirmEmailId: new FormControl('', Validators.required),
    });
    this.alternateEmailForm = new FormGroup({


      alternateEmailId: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern(this.emailRegx),
      ]),
      confirmAlternateEmailId: new FormControl('', Validators.required),
    });
    this.mobileForm = new FormGroup({
      mobileNumber: new FormControl('', [
        Validators.required,
        Validators.minLength(12),
        Validators.maxLength(12),
      ]),
    });
  }
  // ===============================Name field functions=======================
  setNameField() {
    this.nameForm.reset();
    let firstName = '';
    let lastName = '';
    if (this.loginUserInfo?.customerFirstName) {
      firstName = this.loginUserInfo.customerFirstName;
    }
    if (this.loginUserInfo?.customerLastName) {
      lastName = this.loginUserInfo.customerLastName;
    }

    this.nameForm.setValue({
      actualFirstName: firstName,
      actualLastName: lastName,
    });
    this.ref.detectChanges();
  }
  editNameField() {
    this.nameEditIsNotClicked = false;
  }
  updateNameField() {
    this.nameEditIsNotClicked = true;

    const params = {
      customerFirstName: this.nameForm.controls['actualFirstName'].value,
      customerLastName: this.nameForm.controls['actualLastName'].value,
      userName: this.customerId,
      profileUpdateType: 'NAME',
    };
    this.updateAllUserDataFields(params, 'name');
  }
  cancelNameUpdate() {
    this.nameEditIsNotClicked = true;
    this.setNameField();
  }
  // ===============================Role field functions=======================

  userRoleGetMethod() {
    this.pfService.getUserRoles();
    this.userRolesSubscriber = this.pfService.userRoles.subscribe((data) => {
      if (data) {
        this.roleOfUserArray = data;
        this.userRoleMapping();
      }
    });
  }

  userRoleMapping() {
    this.roleOfUserArray.forEach((res) => {
      if (
        this.loginUserInfo?.customerRole &&
        res.name === this.loginUserInfo?.customerRole
      ) {
        this.chosenRoleofUser = res.code;
        this.displayRoleofUser = res.name;
        this.ref.detectChanges();
      }
    });
  }

  editRoleField() {
    this.roleEditIsNotClicked = false;
  }
  updateRoleField() {
    this.roleEditIsNotClicked = true;
    this.roleOfUserArray.forEach((res) => {
      if (res.code === this.chosenRoleofUser) {
        this.displayRoleofUser = res.name;
        this.ref.detectChanges();
      }
    });

    const params = {
      customerRole: this.chosenRoleofUser,
      userName: this.customerId,
      profileUpdateType: 'ROLE',
    };
    this.updateAllUserDataFields(params, 'role');
  }
  cancelRoleUpdate() {
    this.roleEditIsNotClicked = true;
    this.userRoleMapping();
  }
  // ==================================================user disable========================

  editUserIdRadio() {
    this.userIdEditIsNotClicked = false;
  }
  cancelUserIdDisable() {
    this.userIdEditIsNotClicked = true;
    this.userIdDisableReadOnly = (this.loginUserInfo?.userDisabled).toString();
    this.userIdDisable = (this.loginUserInfo?.userDisabled).toString();
  }

  updateUserId() {
    const params = {
      userDisabled: this.userIdDisable,
      userName: this.customerId,
      profileUpdateType: 'USER_DISABLED',
    };
    this.userIdEditIsNotClicked = true;
    this.updateAllUserDataFields(params, 'userId');
  }
  // ================================MFA Disabled Until==============================

  setMfaDisabledUntilField() {
    const raw = this.loginUserInfo?.mfaDisabledUntil;
    const maxHours = this.loginUserInfo?.mfaMaxDisabledHours ?? 72;
    this.mfaDisabledUntilMinDate = new Date();
    this.mfaDisabledUntilMinDate.setHours(0, 0, 0, 0);
    this.mfaDisabledUntilMaxDate = new Date(Date.now() + maxHours * 3600 * 1000);
    if (raw) {
      const parsed = new Date(raw);
      this.mfaDisabledUntilDisplay = parsed.toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short', hour12: false });
      this.mfaDisabledUntilSelectedDate = parsed;
      this.mfaDisabledUntilHour = parsed.getHours();
      this.mfaDisabledUntilMinute = parsed.getMinutes();
    } else {
      this.mfaDisabledUntilDisplay = '';
      this.mfaDisabledUntilSelectedDate = null;
      this.mfaDisabledUntilHour = Math.min(23, new Date().getHours() + 1);
      this.mfaDisabledUntilMinute = 0;
    }
    this.mfaDisabledUntilMinHour = 0;
    this.mfaDisabledUntilErrorMsg = null;
    this.mfaDisabledUntilErrorKey = null;
    this.mfaDisabledUntilErrorParams = {};
    this.mfaDisabledUntilInFlight = false;
    this.mfaDisabledUntilEditIsNotClicked = true;
    this.ref.detectChanges();
  }

  editMfaDisabledUntil() {
    this.mfaDisabledUntilOriginalIso = this.loginUserInfo?.mfaDisabledUntil || null;
    this.mfaDisabledUntilEditIsNotClicked = false;
    this.mfaDisabledUntilErrorMsg = null;
    this.mfaDisabledUntilErrorKey = null;
    this.mfaDisabledUntilErrorParams = {};
    this.onMfaDisabledUntilDateChange(this.mfaDisabledUntilSelectedDate);
  }

  cancelMfaDisabledUntil() {
    this.setMfaDisabledUntilField();
  }

  onMfaDisabledUntilDateChange(date: Date) {
    if (!date) { return; }
    const today = new Date();
    const isToday = date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate();
    this.mfaDisabledUntilMinHour = isToday ? today.getHours() : 0;
    if (isToday && this.mfaDisabledUntilHour <= today.getHours()) {
      this.mfaDisabledUntilHour = this.mfaDisabledUntilMinHour;
      this.mfaDisabledUntilMinute = 0;
    }
    this.mfaDisabledUntilErrorMsg = null;
    this.mfaDisabledUntilErrorKey = null;
    this.mfaDisabledUntilErrorParams = {};
  }

  removeMfaDisabledUntil() {
    this.submitMfaDisabledUntilUpdate({ mfaDisabledUntil: '', userName: this.customerId, profileUpdateType: 'MFA_DISABLE_UNTIL' });
  }

  updateMfaDisabledUntil() {
    this.mfaDisabledUntilErrorMsg = null;
    this.mfaDisabledUntilErrorKey = null;
    this.mfaDisabledUntilErrorParams = {};
    if (!this.mfaDisabledUntilSelectedDate) {
      this.mfaDisabledUntilErrorKey = 'customerOverview.mfaErrorSelectDate';
      this.ref.detectChanges();
      return;
    }
    const combined = new Date(this.mfaDisabledUntilSelectedDate);
    combined.setHours(this.mfaDisabledUntilHour, this.mfaDisabledUntilMinute, 0, 0);
    if (combined <= new Date()) {
      this.mfaDisabledUntilErrorKey = 'customerOverview.mfaErrorFuture';
      this.ref.detectChanges();
      return;
    }
    const maxHours = this.loginUserInfo?.mfaMaxDisabledHours ?? 72;
    if (combined > new Date(Date.now() + maxHours * 3600 * 1000)) {
      this.mfaDisabledUntilErrorKey = 'customerOverview.mfaErrorMaxHours';
      this.mfaDisabledUntilErrorParams = { maxHours };
      this.ref.detectChanges();
      return;
    }
    this.submitMfaDisabledUntilUpdate({ mfaDisabledUntil: this.formatToIso8601(combined), userName: this.customerId, profileUpdateType: 'MFA_DISABLE_UNTIL' });
  }

  private formatToIso8601(date: Date): string {
    const pad = (n: number) => String(n).padStart(2, '0');
    const offsetMins = -date.getTimezoneOffset();
    const sign = offsetMins >= 0 ? '+' : '-';
    const oh = pad(Math.floor(Math.abs(offsetMins) / 60));
    const om = pad(Math.abs(offsetMins) % 60);
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
      `T${pad(date.getHours())}:${pad(date.getMinutes())}:00${sign}${oh}:${om}`;
  }

  private submitMfaDisabledUntilUpdate(params: any) {
    this.mfaDisabledUntilInFlight = true;
    this.updateDetailsSubscriber = this.userManagementService.updateCustDetails.pipe(skip(1), take(1)).subscribe(
      (res: any) => {
        this.mfaDisabledUntilInFlight = false;
        if (res === null) {
          this.mfaDisabledUntilEditIsNotClicked = true;
          this.ref.detectChanges();
          this.userManagementService.getCustomerDetails(this.customerId, 'mfa');
        } else if (res?.error?.errors?.length > 0) {
          this.mfaDisabledUntilErrorMsg = res.error.errors[0]?.message || null;
          this.mfaDisabledUntilErrorKey = this.mfaDisabledUntilErrorMsg ? null : 'customerOverview.mfaErrorUpdate';
          this.ref.detectChanges();
        }
      }
    );
    this.userManagementService.updateCustomerDetails(this.customerId, params);
  }

  // ===============================PassRec==========================================

  getPassWordRecQues() {
    this.pfService.getHintQuestions();
    this.passQueSubscriber = this.pfService.passQues.subscribe((data) => {
      if (data) {
        this.passRecQuesArray = data;
        this.passRecQueMapping();
        this.ref.detectChanges();
      }
    });
  }

  passRecQueMapping() {
    this.passRecQuesArray.forEach((res) => {
      if (
        this.loginUserInfo?.passwordQuestion &&
        this.loginUserInfo?.passwordQuestion !== null &&
        res.name === this.loginUserInfo?.passwordQuestion
      ) {
        this.chosenQueForPassRecovery = res.code;
      }
    });
  }

  setPassRecField() {
    if (
      this.loginUserInfo?.passwordQuestion &&
      this.loginUserInfo?.passwordAnswer
    ) {
      this.displayQueForPassRecovery = this.loginUserInfo?.passwordQuestion;
      this.ansForQuePassRecovery = this.loginUserInfo?.passwordAnswer;
    } else {
      this.displayQueForPassRecovery = '';
      this.ansForQuePassRecovery = null;
    }

    this.ref.detectChanges();
  }
  editPassRecField() {
    this.passRecEditIsNotClicked = false;
  }
  cancelPassRecUpdate() {
    this.passRecEditIsNotClicked = true;
    this.setPassRecField();
    this.passRecQueMapping();
  }

  // ===========================================Email Functions==============================
  setEmailForm() {
    this.emailForm.reset();
    this.emailForm.setValue({
      emailId: this.loginUserInfo?.email,
      confirmEmailId: '',
    });
    this.ref.detectChanges();
  }
  cancelEmailUpdate() {
    this.emailEditIsNotClicked = true;
    this.setEmailForm();
  }
  updateEmailField() {
    const params = {
      email: this.emailForm.controls['emailId'].value,
      confirmEmail: this.emailForm.controls['confirmEmailId'].value,
      userName: this.customerId,
      profileUpdateType: 'EMAIL_CHANGE_REQUEST',
    };
    this.emailEditIsNotClicked = true;
    this.updateAllUserDataFields(params, 'email');
  }
  editEmailField() {
    this.emailEditIsNotClicked = false;
  }

  // ===========================================Mobile Functions==============================
  setMobileForm() {
    this.mobileNumber = this.loginUserInfo?.mobileNumber || '';
    if (this.mobileNumber) {
      const countryCode = this.loginUserInfo?.mobileCountryCode || 'US';
      this.mobileNumberMasked = `(${countryCode}) ` + this.mobileNumber.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '***-***-$3');
    } else {
      this.mobileNumberMasked = '';
    }
    this.mobileForm.reset();
    this.mobileForm.patchValue({ mobileNumber: this.mobileNumber });
    this.ref.detectChanges();
  }
  editMobileField(state: string) {
    if (state === 'edit') {
      this.mobileEditIsNotClicked = false;
      this.mobileErrorMsg = null;
      this.ref.detectChanges(); // render input so appPhoneMask directive initialises
      setTimeout(() => {
        // re-set raw digits after directive is active so it formats to XXX-XXX-XXXX
        const raw = (this.mobileNumber || '').replace(/\D/g, '');
        this.mobileForm.controls['mobileNumber'].setValue(raw);
        this.ref.detectChanges();
      });
    } else {
      this.mobileEditIsNotClicked = true;
      this.mobileErrorMsg = null;
      this.ref.detectChanges(); // destroy directive before resetting form
      this.setMobileForm();
    }
  }
  validateMobileForm() {
    this.mobileErrorMsg = null;
  }
  updateMobileField() {
    this.mobileAddDisable = true;
    this.mobileErrorMsg = null;
    const params = {
      mobileNumber: this.mobileForm.controls['mobileNumber'].value
        ? this.mobileForm.controls['mobileNumber'].value.replace(/\D/g, '')
        : '',
      userName: this.customerId,
      profileUpdateType: 'MOBILE_CHANGE_REQUEST',
    };
    this.updateMobileData(params);
  }
  removeMobile() {
    this.mobileAddDisable = true;
    this.mobileErrorMsg = null;
    const params = {
      mobileNumber: '',
      userName: this.customerId,
      profileUpdateType: 'MOBILE_REMOVE',
    };
    this.updateMobileData(params);
  }
  updateMobileData(params: any) {
    this.userManagementService.updateCustomerDetails(this.customerId, params);
    this.updateDetailsSubscriber =
      this.userManagementService.updateCustDetails.pipe(skip(1), take(1)).subscribe(
        (res: any) => {
          this.mobileAddDisable = false;
          if (res === null) {
            this.mobileEditIsNotClicked = true;
            this.userManagementService.getCustomerDetails(this.customerId, 'mobile');
          } else if (res?.error?.errors?.length > 0) {
            this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
            this.mobileErrorMsg = res.error.errors[0]?.message
              || 'Some error occurred while updating mobile number.';
            this.ref.detectChanges();
          }
        }
      );
  }

  // ==================================UpdateDetals==========================
  updateAllUserDataFields(params, id) {
    this.userManagementService.updateCustomerDetails(this.customerId, params);
    this.updateDetailsSubscriber =
      this.userManagementService.updateCustDetails.subscribe(
        (res: any) => {
          if (res === null) {
            this.userManagementService.getCustomerDetails(this.customerId, id);
            this.updateDetailsSubscriber?.unsubscribe();
          } else {
            this.emailChangeRequested = id === 'email';
            if (res && res?.error?.errors?.length > 0) {
              //in service emitting error also as response.
              window.scrollTo(0, 0);
              let errMssg = res?.error?.errors[0]?.message
                ? res?.error?.errors[0]?.message
                : `Some error occured while updating the ${id} field.`;
              this.userManagementService.getCustomerDetails(
                this.customerId,
                id
              );
              this.updateDetailsSubscriber?.unsubscribe();
            }
          }
        },
        (err) => {
          if (err?.error?.errors?.length > 0) {
            window.scrollTo(0, 0);
            let errMssg = err?.error?.errors[0]?.message
              ? err?.error?.errors[0]?.message
              : `Some error occured while updating the ${id} field.`;
          }
          this.userManagementService.getCustomerDetails(this.customerId, id);
          this.updateDetailsSubscriber?.unsubscribe();
        }
      );
  }

  // ============================resetPasswordLink====================
  resetPasswordLink() {
    this.userManagementService.resetPasswordService(this.customerId, {});
    this.userManagementService.resetPasswordDetails.subscribe((data: any) => {
      if (data) {
        if (data?.resetPasswordEmailSent) {
          this.resetPasswordBoolean = data?.resetPasswordEmailSent;
        } else {
          this.resetPasswordBoolean = false;
        }
        this.ref.detectChanges();
      }
    });
  }
  backToView() {
    this.router.navigate(['/', 'userManagemt']);
  }
}
